export default {
  zip: 'SIGN_IN_FLOW_STEP_ZIP',
  socialContinue: 'SIGN_IN_FLOW_SOCIAL_CONTINUE',
  signUp: 'SIGN_IN_FLOW_SIGN_UP',
  signIn: 'SIGN_IN_FLOW_SIGN_IN',
};
